import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Chatbot from './components/Chatbot';
import HomePage from './pages/HomePage';
import StatePage from './pages/StatePage';
import StateDetail from './pages/StateDetail';
import './index.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50">
        <Header />
        <motion.main
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="pt-20"
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/states" element={<StatePage />} />
            <Route path="/states/:state" element={<StateDetail />} />
          </Routes>
        </motion.main>
        
        {/* Chatbot Component */}
        <Chatbot />
      </div>
    </Router>
  );
}

export default App;